import { useMutation, gql } from '@apollo/react-hooks';
import { useCallback } from 'react';
import type { CreateFindingMutation, FindingInput } from '#/graphql/types';
import { createFinding } from '#/graphql/mutations';
import { get } from 'lodash';

const q = gql(createFinding);

const useFindingCreate = () => {
  const [mutation, result] = useMutation<CreateFindingMutation>(q);
  const createFinding = useCallback(
    async (data: FindingInput) => {
      const response = await mutation({
        variables: {
          data,
        },
      });

      const result = get(response, 'data.createFinding', undefined);

      // Check if the operation failed on the backend
      if (result && result.status !== 200) {
        const errorMessage = result.errors?.join('\n') || 'Create failed';
        throw new Error(errorMessage);
      }

      return result;
    },
    [mutation],
  );

  return { createFinding, result };
};

export default useFindingCreate;
